var map = {
	"./auditLogs.js": "a4b6",
	"./auth.js": "6bf2",
	"./dashboard.js": "d049",
	"./ftp.js": "5c55",
	"./index.js": "dde5",
	"./invoices.js": "f6a0",
	"./invoicesAdvance.js": "4bda",
	"./notifications.js": "4eb0",
	"./orders.js": "1181",
	"./procurementScheme.js": "0944",
	"./roles.js": "6198",
	"./structures.js": "16b6",
	"./suppliers.js": "6242",
	"./syncAuditLogs.js": "acc1",
	"./translations.js": "e6ca",
	"./users.js": "5b34"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "85d1";